import * as React from 'react';
import { WidgetProps } from '@rjsf/core';
import * as ThemeUI from 'theme-ui';
import { useIntl } from 'lib/intl';
import { Text } from 'components/typography';
import { LocaleKey } from '../../../../translations';

/*
 * A single boolean checkbox, left-aligned with the label inline to its
 * right. Mirrors the styling of the multi-option `CheckboxesWidget` so it
 * looks consistent with the rest of the form.
 * */
export function CheckboxWidget(props: WidgetProps) {
  const intl = useIntl();

  const onChange = ({
    target: { checked },
  }: React.ChangeEvent<HTMLInputElement>) => props.onChange(checked);

  return (
    <ThemeUI.Label
      htmlFor={props.id}
      sx={{
        display: 'flex',
        alignItems: 'center',
        width: 'fit-content',
        py: 1,
        cursor: props.disabled || props.readonly ? 'not-allowed' : 'pointer',
        /**
         * ThemeUI adds 'position: absolute' to the inner checkbox element,
         * so we add 'position: relative' here to contain it.
         * */
        position: 'relative',

        '& input:checked ~ svg': {
          color: 'secondary.500',
        },
        '& input:focus ~ svg': {
          backgroundColor: '#B5D5FF',
        },
        '& input:not(:checked) ~ svg': {
          color: 'grey.900',
        },
      }}
    >
      <ThemeUI.Checkbox
        sx={{ mr: 3 }}
        id={props.id}
        name={props.id}
        checked={Boolean(props.value)}
        disabled={props.disabled || props.readonly}
        autoFocus={props.autofocus}
        onChange={onChange}
      />

      <Text sx={{ fontSize: 'lg', fontWeight: 500 }}>
        {intl.formatMessage({ id: props.label as LocaleKey })}
      </Text>
    </ThemeUI.Label>
  );
}

